module.exports = __webpack_public_path__ + "static/logo-footer-dda7add2cb8df497336937c024981052.png";